import { useEffect, useState } from 'react';
import { collection, onSnapshot, orderBy, query } from 'firebase/firestore';
import { db } from '@/lib/firebase';
import type { Part } from '@/types/Part';

export interface UsePartsResult {
  parts: Part[];
  loading: boolean;
  error: string | null;
}

/**
 * Real-time subscription to all /parts docs. Used by admin + customer
 * inventory views. Customer-side reads are still gated by firestore
 * rules (active subscription required); admin reads pass via the
 * isAdmin branch in the rules.
 */
export function useParts(): UsePartsResult {
  const [parts, setParts] = useState<Part[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const q = query(collection(db, 'parts'), orderBy('updatedAt', 'desc'));
    const unsub = onSnapshot(
      q,
      (snap) => {
        const next = snap.docs.map((d) => ({ id: d.id, ...d.data() } as Part));
        setParts(next);
        setLoading(false);
      },
      (err) => {
        console.error('useParts snapshot error', err);
        setError(err.message);
        setLoading(false);
      }
    );
    return unsub;
  }, []);

  return { parts, loading, error };
}
